export const FetchKeys = {
  wellbeingData: 'wellbeingData',
  wellbeingEmotionsData: 'wellbeingEmotionsData',
  adoptionData: 'adoptionData',
  appEngagementData: 'appEngagementData',
  coachingUtilisationData: 'coachingUtilisationData',
  teamsAndCountries: 'teamsAndCountries',
  organisationsList: 'organisationsList',
  dimensionsData: 'dimensionsData',
  dimensionStat: 'dimensionStat',
  reportsData: 'reportsData',
  reportGenerateData: 'reportGenerateData',
  reportDownloadData: 'reportDownloadData',
};

export const ssoNotEnabledCode = 1002;
